<div class="spinner" *ngIf="!isEnabled">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>





<!-- updated code -->

<div class="stikytop"></div>
<div class="listingParallax" *ngIf="isEnabled">
    <div class="container" style="text-align: center;">
        <div class="row" style="height: 100px;"></div>
        <h1 class="mt-5" style="color: #7ACCF6;">PROPERTY DETAILS</h1>
    </div>
</div>
<div class="container propotion" style=" padding-top: 50px; background-color: #ffffff">
    <div class="row">
        <div class="col-8">
            <h2 class="contentsize" style="padding-left: 22px;">{{propData?.property_title}}</h2>
        </div>
        <div class="col-4">
            <!-- <h3 class="contentpricesize" style="color: #891b1d;" *ngIf="propData?.property_price != 0">
                <b>{{propData?.currency_type == 1 ? "$" : ""}}{{propData?.property_price}}
                    {{propData?.currency_type == 2 ? "DUC" : ""}} {{propData?.currency_type == 3 ? "BTC" : ""}}</b></h3> -->
            <!-- <h3 class="contentpricesize" style="color: #414141; text-align: right;padding-right: 10%;"
                *ngIf="propData?.property_price != 0">
                <b>{{propData?.property_price}}</b></h3> -->
        </div>
    </div>
</div>
<div class="container propotion" *ngIf="isEnabled" style="padding-bottom: 50px; background-color: #ffffff">
    <div class="row">
        <div class="col-lg-8" style="margin-bottom: 50px;">
            <div class="container">
                <div class="">
                    <div class="col-md-12">
                        <div class="item promoted" [attr.data-awards]="actionName8">
                            <div id="custCarousel9" class="carousel slide" data-ride="carousel" align="center">
                                <div class="carousel-inner" (click)="viewImage(imageModal)">

                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of propGalary; let i = index'> <img
                                            src={{server_url}}{{fav?.image_url}} alt="Hills">
                                        <div class="carousel-caption ">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#custCarousel9" data-slide="prev"> <span
                                    class="carousel-control-prev-icon"></span> </a> <a class="carousel-control-next"
                                href="#custCarousel9" data-slide="next"> <span
                                    class="carousel-control-next-icon"></span>
                            </a>
                            <ol class="carousel-indicators list-inline" style="display: inline-flex;">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of propGalary; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#custCarousel9">
                                        <img src={{server_url}}{{fav?.image_url}} class="img-fluid thumlineimg">
                                    </a> </li>
                            </ol>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <h3 class="contentpricesize" *ngIf="propData?.property_price_usd != 0">
                <b>{{propData?.property_price}}</b></h3>
            <p class="contentpricesize" *ngIf="propData?.property_status == 'Price Upon Request'">Price Upon Request</p>
            <h5 *ngIf="propData.duc_back_perc" style="font-size: large; color: #891b1d;margin-top: 5%;margin-bottom: 4%;">{{propData.duc_back_perc}}</h5>
            <h5 *ngIf="propData.property_subtitle" style="font-size: large;">{{propData.property_subtitle}}</h5>
            <br *ngIf="propData.property_type">
            <p *ngIf="propData.property_type"><b>PROPERTY TYPE:</b> {{propData.property_type}}</p>
            <p *ngIf="propData.property_status"><b>PROPERTY STATUS:</b> {{propData.property_status}}</p>
            <!-- <p *ngIf="propData.property_desc" style="text-align:justify;">{{propData.property_desc}}</p> -->
            <p *ngIf="propData?.property_desc" style="font-size: smaller;">
                <span *ngFor="let desc of propData?.property_desc; let i = index">{{desc}}
                    <br><br></span>
            </p>

            <button class="btn btn-outline-default brochureBtn" (click)="download(propData)"
                [disabled]='isDownloadClicked' style="outline: none;box-shadow: none;"
                *ngIf="propData.brochure_url != ''">
                {{isDownloadClicked ? 'Downloading...': "DOWNLOAD BROCHURE"}}</button>
        </div>
    </div>






    <!-- images modal -->


    <ng-template #imageModal let-modal>
        <!-- <div class="modal-header modalBackground">
            <h4 class="modal-title" ngbAutofocus id="modal-basic-title">
            </h4>
            <button type="button" class="btn btn-default" style="color: #fff;" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div> -->
        <div class="modal-body pb-5 modalBackground">
            <div class="row">
                <h4 class="modal-title" ngbAutofocus id="modal-basic-title">
                </h4>
                <button type="button" class="btn btn-default float-right"
                    style="color: #fff; text-align: right; font-size: 30px;" aria-label="Close"
                    (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div>
                <div class="col-md-12">
                    <div class="item promoted" [attr.data-awards]="actionName8">
                        <div id="custCarousel10" class="carousel slide" data-ride="carousel" align="center">
                            <div class="carousel-inner">

                                <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of propGalary; let i = index'> <img
                                        src={{server_url}}{{fav?.image_url}} alt="Hills">
                                    <div class="carousel-caption ">
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#custCarousel10" data-slide="prev"> <span
                                    class="carousel-control-prev-icon"></span> </a> <a class="carousel-control-next"
                                href="#custCarousel10" data-slide="next"> <span
                                    class="carousel-control-next-icon"></span>
                            </a>
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of propGalary; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#custCarousel10">
                                        <img src={{server_url}}{{fav?.image_url}} class="img-fluid">
                                    </a> </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </ng-template>